/**
 * @prettier
 */

import React from 'react';
import { connect } from 'react-redux';

// Redux
import * as selectors from 'cards/reducers/pdp/selectors';
import { getPricing } from 'cards/reducers/pricing/selectors';

// Utils
import { getOptionPricing } from 'cards/components/CardDetail/AllOptionsSection/utils';
import { formatPrice } from 'components/product/helpers';

import descriptions from './descriptions';

import styles from './styles.module.less';

const QualityText = ({ title, body }) => (
  <div className={styles.tileQualityItem}>
    <div className={styles.tileQualityItemHeader}>{title}</div>
    <div className={styles.tileQualityItemBody}>{body}</div>
  </div>
);

const Tile = ({ header, priceDelta, description, imageSrc, feel, ideal, why }) => {
  return (
    <div className={styles.tile}>
      <div className={styles.tileHeaderBox}>
        <div className={styles.tileHeader}>{header}</div>
        <div className={styles.tilePrice}>+ {formatPrice(priceDelta, null, 2)} Ea.</div>
      </div>
      <div className={styles.tileDescription}>{description}</div>
      <div>
        <img className={styles.tileImage} src={imageSrc} alt={`${header} Paper Type`} />
      </div>
      <div className={styles.tileQualityBox}>
        <QualityText title="Feels Like" body={feel} />
        <QualityText title="Ideal For" body={ideal} />
        <QualityText title="Why We Love It" body={why} />
      </div>
    </div>
  );
};

export const ComparisonModuleBase = ({
  pricing,
  cardType,
  activeMediumKey,
  activeSelection,
  hideProofBanner,
  overrides = {},
}) => {
  const optionPricing =
    getOptionPricing(
      pricing || overrides.pricing,
      cardType || overrides.cardType,
      activeMediumKey || overrides.activeMediumKey,
      activeSelection.size || (overrides.activeSelection && overrides.activeSelection.size),
      'size'
    ) || {};

  const priceDeltas = optionPricing['paper-type'] || {};

  const tileProps = descriptions
    .filter(description => Object.prototype.hasOwnProperty.call(priceDeltas, description.id))
    .map(description => ({
      ...description,
      priceDelta: priceDeltas[description.id],
    }));

  return (
    <div className={styles.box}>
      <div className={styles.title}>Our Paper Collection</div>
      {!hideProofBanner && (
        <div className={styles.proofBanner}>
          Want a free personalized proof? Customize a design, then order a proof on the “Review”
          page with code <b>FREEPROOF.</b>
        </div>
      )}
      <div className={styles.tilesContainer}>
        {tileProps.map(props => (
          <Tile key={props.id} {...props} />
        ))}
      </div>
    </div>
  );
};

export const mapStateToProps = state => ({
  pricing: getPricing(state),
  cardType: selectors.getCardType(state),
  activeMediumKey: selectors.getActiveMediumKey(state),
  activeSelection: selectors.getActiveSelection(state),
});

export default connect(mapStateToProps)(ComparisonModuleBase);
